module.exports = "https://dev.stanwinstonschool.com/startrek_poster_alt.8fe07b6dbeb2f98ae60c6b2a62eda439.jpg";